import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Wrapper = styled.button`
  @media print {
    display:inline-block; 
  }
  border-radius: ${({ theme }) => theme.radius.small}px;
  background-color: ${({ theme }) => theme.palette.blue.lighter};
  font-weight: bold;
  padding: ${({ theme }) => theme.spacer * 1.5}px
    ${({ theme }) => theme.spacer * 2}px;
`;

const RoundedButton = ({ className, children, onClick, ...rest }) => {
  const classes = ["RoundedButton"];
  if (className) classes.push(className);

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Wrapper onClick={onClick} className={classes.join(" ")} {...rest}>
      {children}
    </Wrapper>
  );
};

RoundedButton.displayName = "RoundedButton";

RoundedButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
};

RoundedButton.defaultProps = {
  className: null,
};

export default RoundedButton;
